module.exports = "../images/family-fishing.jpg?v=53e881b";